import { createFileRoute } from '@tanstack/react-router';
import { MemberResourcesPage } from '@/pages/resources/MemberResourcesPage';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	search: z.string().optional(),
	categoryId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/resources')({
	validateSearch: searchSchema,
	component: MemberResourcesPage,
});
